module.exports = __webpack_public_path__ + "img/01_icon_2.d997234a.svg";